<div class="bg-white rounded-2xl shadow-2xl overflow-hidden w-full max-w-2xl mx-auto flex flex-col max-h-[92vh]">
  <!-- Header -->
  <div class="px-6 py-4 border-b border-gray-100 flex items-center justify-between shrink-0">
    <div class="flex items-center gap-3">
      <div class="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shrink-0 shadow-sm">
        <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0M12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      </div>
      <div>
        <h2 class="text-lg font-bold text-gray-900 leading-tight">New employee</h2>
        <p class="text-xs text-gray-400">Invite a team member by email</p>
      </div>
    </div>
    <button type="button" (click)="closeModal()" class="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
    </button>
  </div>

  <div class="px-6 py-5 overflow-y-auto flex-1 min-h-0 bg-gray-50/40 custom-scrollbar">
    @if (showSuccess()) {
    <div class="p-8 bg-white border border-emerald-200 rounded-2xl flex flex-col items-center text-center">
      <div class="w-16 h-16 rounded-full bg-emerald-500 flex items-center justify-center mb-4 shadow-sm">
        <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7" /></svg>
      </div>
      <h3 class="font-bold text-xl text-gray-900 mb-1">Invitation sent</h3>
      <p class="text-sm text-gray-500 mb-4">An invitation email has been sent to:</p>
      <div class="px-5 py-2.5 bg-emerald-50 rounded-lg border border-emerald-200 mb-6">
        <p class="font-semibold text-emerald-700">{{ successEmail() }}</p>
      </div>
      <div class="bg-blue-50 border border-blue-100 rounded-xl p-4 mb-6 text-left max-w-md w-full">
        <div class="flex items-start gap-3">
          <svg class="w-5 h-5 text-blue-500 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
          <div class="text-sm text-blue-700">
            <p class="font-semibold mb-1">The user will receive:</p>
            <ul class="list-disc list-inside space-y-1 text-blue-600">
              <li>Login credentials via email</li>
              <li>A secure temporary password</li>
              <li>Instructions to sign in</li>
            </ul>
            <p class="mt-2 text-xs text-blue-500">They'll be required to change their password on first login.</p>
          </div>
        </div>
      </div>
      <div class="flex gap-2 w-full">
        <button (click)="closeModal()" class="flex-1 py-2.5 rounded-lg text-gray-700 text-sm font-medium bg-white border border-gray-200 hover:bg-gray-100 transition-colors cursor-pointer">Close</button>
        <button (click)="showSuccess.set(false)" class="flex-1 py-2.5 rounded-lg text-white text-sm font-semibold bg-blue-600 hover:bg-blue-700 transition-colors shadow-sm cursor-pointer">Invite another</button>
      </div>
    </div>
    }
    @else {
    @if(error()) {
    <div class="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl flex items-start gap-2">
      <svg class="w-5 h-5 text-red-500 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
      <p class="text-sm text-red-700">{{ error() }}</p>
    </div>
    }

    <form [formGroup]="form" (ngSubmit)="onSubmit($event)" id="addEmployeeForm" class="space-y-5">
      <div class="rounded-xl border border-gray-200 bg-white p-4 space-y-4">
        <div class="flex items-center gap-1.5 text-xs text-gray-400 font-bold uppercase tracking-wider">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0M12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
          Identity
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div class="flex flex-col">
            <label class="text-xs text-gray-500 font-semibold mb-1.5 uppercase tracking-wide">First name</label>
            <input type="text" formControlName="firstName" placeholder="Required"
              class="border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none placeholder-gray-400 transition" />
          </div>
          <div class="flex flex-col">
            <label class="text-xs text-gray-500 font-semibold mb-1.5 uppercase tracking-wide">Last name</label>
            <input type="text" formControlName="lastName" placeholder="Required"
              class="border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none placeholder-gray-400 transition" />
          </div>
        </div>
        <div class="flex flex-col">
          <label class="text-xs text-gray-500 font-semibold mb-1.5 uppercase tracking-wide">Email</label>
          <input type="email" formControlName="email" placeholder="user@example.com"
            class="border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none placeholder-gray-400 transition" />
        </div>
        <div class="flex flex-col">
          <label class="text-xs text-gray-500 font-semibold mb-1.5 uppercase tracking-wide">Tenant</label>
          <div class="relative">
            <select formControlName="tenantId"
              class="w-full appearance-none border border-gray-300 rounded-lg pl-3.5 pr-9 py-2.5 text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none cursor-pointer transition">
              <option value="" disabled>Select a tenant</option>
              @for(tenant of tenants; track tenant.id) { <option [value]="tenant.id">{{ tenant.name }}</option> }
            </select>
            <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" /></svg>
          </div>
        </div>
      </div>
    </form>
    }
  </div>

  @if (!showSuccess()) {
  <div class="px-6 py-3.5 border-t border-gray-100 flex justify-end gap-2 bg-gray-50/50 shrink-0">
    <button type="button" (click)="closeModal()" class="px-4 py-2.5 text-gray-700 text-sm font-medium hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">Cancel</button>
    <button type="submit" form="addEmployeeForm" [disabled]="isSubmitting()"
      class="bg-blue-600 text-white text-sm font-semibold py-2.5 px-5 rounded-lg hover:bg-blue-700 disabled:opacity-50 transition-colors shadow-sm cursor-pointer flex items-center gap-2">
      @if(isSubmitting()) { <span class="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></span> }
      Invite user
    </button>
  </div>
  }
</div>
